
import { Options, Vue, prop } from "vue-class-component";
import ButtonBooking from "@/app/ui/components/button-list/index.vue";

class Props {
  isDisabled = prop<boolean>({
    default: false,
    type: Boolean,
  });
}

@Options({
  emits: ["setDiscount", "submit"],
  components: {
    ButtonBooking
  },
})
export default class BookV3 extends Vue.with(Props) {
  get menus() {
    return [
      {
        title: this.$t("bookingV3.bookButton.printLater"),
        icon: "check-circle-red",
      },
      {
        title: this.$t("bookingV3.bookButton.printThermal"),
        icon: "document-download-red",
      },
      {
        title: this.$t("bookingV3.bookButton.printThermalPdf"),
        icon: "document-download-red",
      },
      {
        title: this.$t("bookingV3.bookButton.printA4Pdf"),
        icon: "printer-red",
      },
    ];
  }

  async action(index: number) {
    const typeBook: any = {
      0: "book-print-later",
      1: "book-print-thermal",
      2: "book-print-thermal-pdf",
      3: "book-print-pdf",
    };

    this.$emit("submit", typeBook[index]);
  }
}
